import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const KidsPlayArea = () => {
  const [activeImage, setActiveImage] = useState(0);

  const facilityData = {
    name: 'Kids Play Area',
    category: 'Family',
    description: 'Safe and fun play area for children with supervision.',
    longDescription: 'Our dedicated Kids Play Area provides a safe, engaging environment where children can play, learn, and make friends. Featuring age-appropriate equipment, soft play areas, and supervised activities, it offers parents peace of mind while kids have the time of their lives. Regular programs include arts and crafts, storytelling, and supervised games.',
    images: [
      getImagePath('images/bars/kids-play-area.jpg'),
      getImagePath('images/bars/kids-play-area.jpg'),
      getImagePath('images/bars/kids-play-area.jpg')
    ],
    icon: 'fa-child',
    capacity: '30 children',
    hours: 'Daily: 9am - 7pm',
    features: [
      'Play Structures',
      'Supervised Activities',
      'Arts & Crafts',
      'Storytelling',
      'Soft Play Area',
      'Age-Appropriate Toys',
      'Birthday Parties',
      'Parent Lounge'
    ],
    amenities: ['Changing Facilities', 'Snack Area', 'Security', 'First Aid'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'kids@nlngraclub.com',
      extension: '115'
    },
    activities: ['Arts & Crafts', 'Story Time', 'Games', 'Music & Movement'],
    parties: ['Birthday Packages', 'Holiday Events', 'Theme Days']
  };

  return (
    <div className="facility-detail-page">
      {/* Hero Section */}
      <section className="facility-detail-hero">
        <div className="hero-background">
          <img src={facilityData.images[0]} alt={facilityData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/facilities" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Facilities
            </Link>
            <span className="facility-category">{facilityData.category}</span>
            <h1 className="facility-title">{facilityData.name}</h1>
            <p className="facility-subtitle">{facilityData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Facility Content */}
      <section className="facility-content-section">
        <div className="container">
          <div className="facility-grid">
            {/* Left Column - Images */}
            <div className="facility-gallery">
              <div className="main-image">
                <img 
                  src={facilityData.images[activeImage]} 
                  alt={facilityData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {facilityData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${facilityData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="facility-details">
              <div className="detail-section">
                <h2>About {facilityData.name}</h2>
                <p className="facility-description">{facilityData.longDescription}</p>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {facilityData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <h4>Hours</h4>
                  <p>{facilityData.hours}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <h4>Capacity</h4>
                  <p>{facilityData.capacity}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-phone"></i>
                  <h4>Contact</h4>
                  <p>{facilityData.contact.phone} ext. {facilityData.contact.extension}</p>
                </div>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Activities:</span>
                  <span className="info-value">{facilityData.activities.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Parties:</span>
                  <span className="info-value">{facilityData.parties.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-calendar-check"></i> Book a Party
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-envelope"></i> Activity Schedule
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KidsPlayArea;